import pb from '../lib/pocketbase';

export async function getBodegas(page, perPage) {
  return await pb.collection('bodega').getList(page, perPage, {
    sort: '-created',
    $autoCancel: false,
    expand: 'sucursal'
  });
}

export async function createBodega(bodega) {
  return await pb.collection('bodega').create(bodega);
}

export async function updateBodega(id, bodega) {
  return await pb.collection('bodega').update(id, bodega);
}

export async function deleteBodega(id) {
  return await pb.collection('bodega').delete(id);
}